<script setup lang='ts'>

</script>

<template>
  <div class="w-full flex">
    <div>
      <n-skeleton class="rounded-md overflow-hidden w-52 aspect-16/9 h-auto" />
    </div>
    <div class="flex-grow w-0 ml-2 pt-1">
      <n-skeleton text class="w-60%" />
      <n-skeleton text class="w-100% mt-2" />
      <n-skeleton text class="w-100% " />
      <n-skeleton text class="w-30% mt-sm" />
    </div>
  </div>
</template>
